import { lazy, Suspense, type ReactNode } from 'react';
import { Navigate, type RouteObject } from 'react-router';
import { PageLoader } from '@dezza/ui';
import { PageSkeleton } from '../../components/Page';

const XrayPage = lazy(() => import('./xray/XrayPage'));
const EntriesPage = lazy(() => import('./entries/EntriesPage'));
const AccountsPage = lazy(() => import('./accounts/AccountsPage'));
const AccountDetailPage = lazy(() => import('./accounts/AccountDetailPage'));
const TransfersPage = lazy(() => import('./transfers/TransfersPage'));
const DrePage = lazy(() => import('./dre/DrePage'));
const DrePrintPage = lazy(() => import('./dre/DrePrintPage'));
const CashflowPage = lazy(() => import('./cashflow/CashflowPage'));
const RecurrencesPage = lazy(() => import('./recurrences/RecurrencesPage'));
const ReconciliationPage = lazy(() => import('./reconciliation/ReconciliationPage'));
const GoalsPage = lazy(() => import('./goals/GoalsPage'));
const CategoriesPage = lazy(() => import('./categories/CategoriesPage'));
const CashPage = lazy(() => import('./cash/CashPage'));
const CashSessionPage = lazy(() => import('./cash/CashSessionPage'));
const CashPrintPage = lazy(() => import('./cash/CashPrintPage'));

const load = (el: ReactNode, variant: 'list' | 'dashboard' = 'list') => <Suspense fallback={<PageSkeleton variant={variant} />}>{el}</Suspense>;
const print = (el: ReactNode) => <Suspense fallback={<PageLoader label="Preparando a impressão..." />}>{el}</Suspense>;

/**
 * Rotas de Finanças (dentro do shell autenticado). /financas é o Raio-X do mês; cada seção tem a
 * sua rota para os links (alertas, paleta de comandos, Raio-X) abrirem direto no lugar certo.
 */
export const routes: RouteObject[] = [
  { path: 'financas', element: load(<XrayPage />, 'dashboard') },
  { path: 'financas/lancamentos', element: load(<EntriesPage />) },
  { path: 'financas/contas', element: load(<AccountsPage />, 'dashboard') },
  { path: 'financas/contas/:id', element: load(<AccountDetailPage />) },
  { path: 'financas/transferencias', element: load(<TransfersPage />) },
  { path: 'financas/dre', element: load(<DrePage />, 'dashboard') },
  { path: 'financas/fluxo', element: load(<CashflowPage />, 'dashboard') },
  { path: 'financas/recorrentes', element: load(<RecurrencesPage />) },
  { path: 'financas/conciliacao', element: load(<ReconciliationPage />) },
  { path: 'financas/metas', element: load(<GoalsPage />, 'dashboard') },
  { path: 'financas/categorias', element: load(<CategoriesPage />) },
  { path: 'financas/caixa', element: load(<CashPage />) },
  { path: 'financas/caixa/:id', element: load(<CashSessionPage />) },
  { path: 'financas/*', element: <Navigate to="/financas" replace /> },
];

/** Rotas protegidas sem o shell (impressão). */
export const fullscreenRoutes: RouteObject[] = [
  { path: 'financas/caixa/:id/imprimir', element: print(<CashPrintPage />) },
  { path: 'financas/dre/imprimir', element: print(<DrePrintPage />) },
];
